/**
 * spm 注册到神策全局（页面级公共属性）：当前页前向来源写入 sensorProvider 的
 * registerPage 页面公共属性，内置全埋点事件（$WebClick/$WebPageLoad/$WebPageLeave
 * 等）与自定义事件一样携带站内来源，与神策 $latest_* 渠道归因互补。
 *
 * 首次注册在 sensorProvider 初始化（registerCommonProperties）中完成；SDK 的
 * is_track_single_page 回调在自动页面浏览构造前同步刷新与清除。
 * 本模块由 useEventReportingInit 的路由 effect 调用，作为页面公共属性的补充同步，
 * 自动页面浏览的来源正确性不依赖 effect 时序。
 */
import { ReportingCenter } from '../reportingCenter';
import { ProviderType } from '../types';

import { getPageReferSpm } from './spm-session';

/** sensorProvider 刷新页面公共属性的最小接口（避免依赖具体类）。 */
interface SpmPagePropertyProvider {
  refreshSpmPageProperty?(spm: string | undefined): void;
}

export function syncSpmToSensorsPageProperties(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const provider = ReportingCenter.getInstance().getProvider(ProviderType.SENSORS) as
    | SpmPagePropertyProvider
    | undefined;
  provider?.refreshSpmPageProperty?.(getPageReferSpm());
}
